export default "__VITE_ASSET__DOkGOE2C__"